import type { OutflowOfferMobileProps, OutflowOfferWebProps } from 'reactApp/modules/subscriptionRenewal/outflowOffers/offers.types';
import { captchaAndSurvey, captchaAndSurveyMobile } from 'reactApp/modules/subscriptionRenewal/outflowOffers/offers/captchaAndSurvey';

export function* captchaWeb(props: OutflowOfferWebProps) {
    yield captchaAndSurvey({ ...props, showSurvey: false });
}

export function* captchaMobile(props: OutflowOfferMobileProps) {
    yield captchaAndSurveyMobile({ ...props, showSurvey: false });
}
